import { Injectable, inject } from '@angular/core';
import { AuthService } from '@joyinvoice/web/shared/data-access';

@Injectable({ providedIn: 'root' })
export class TenantService {
  private readonly auth = inject(AuthService);

  getCurrentTenantId(): number | null {
    const tenant = this.auth.currentTenant();
    return tenant?.id ?? null;
  }

  getTenantName(): string {
    return this.auth.currentTenant()?.name ?? 'Joy Invoice';
  }
}
